/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";

export default function FAQsList(props) {
  const data = [];
  props.faqs.forEach(function(value){
    value.ans = value.ans.replace(/(?:\r\n|\r|\n|↵)/g, '<br />');
    data.push(value);
  });
  // const data = [
  //   {
  //     _id: "58ef666eeb5d49667c934ada",
  //     ans:
  //       "Instant Consult provides you with the ability to have a health consultation with a patient via video call, anywhere in Australia. We provide a platform for effective health consultations supplementing the traditional health care system. The ultimate benefit of Instant Consult is the convenience; not only to patients, but to yourself. You can work from home, your office, at the airport, in between in-room consultations, and even travelling.",
  //     query: "What is Instant Consult?"
  //   },
  //   {
  //     _id: "58f0ad4560338a78654cd3f0",
  //     ans:
  //       "In consultation with a patient, you can use Instant Consult to issue Medical Certificates, Prescriptions (including Repeats), Specialist Referrals, Pathology Requests and Radiology Requests. You can also speak to patients for just about any general medical issue, including cold and flu, sore throat, sexual health, diarrhoea, vomiting and more. Instant Consult believes over 80% of typical medical consultations can be effectively managed online via video call. Using Instant Consult takes pressure off medical practices as well as after hour hospital visits, letting these departments focus on physical examination and genuine emergency care.↵↵The consults are charged according to the duration of the consult – not what medical documents you issue to patients. Just like any consultation where patients were to visit a local medical clinic, we cannot guarantee what medical documents the doctor will issue them. The patient will have to have a consultation where you can ask about their health history, symptoms and any other details required, so you can make an informed decision as to whether or not the consult will result in a medical document being supplied.",
  //     query: "What can I use Instant Consult for?"
  //   },
  //   {
  //     _id: "58f0ad6660338a78654cd3f1",
  //     ans:
  //       "If a patient needs emergency medical attention in Australia dial 000. Examples of medical emergencies include: chest pain, head or spinal injuries, severe bleeding, loss of movement, breathing difficulties and reduced level of consciousness. If they are showing any signs of this and the patient is able to make a phone call, you should advise the patient to call 000 immediately as well.",
  //     query: "What should I do in cases of emergency with a patient?"
  //   },
  //   {
  //     _id: "5975ce7de46e6343f2479970",
  //     ans:
  //       "Once you accept the consult request you should call the patient within 5 minutes by clicking on Call. In this 5 minutes, we advise you to search for the patient’s record in the search bar at the top of your screen, and reviewing their consult history, so you are prepared for the consultation.",
  //     query:
  //       "How do I connect with the patient once I accept their consult request?"
  //   },
  //   {
  //     _id: "5975ceb9e46e6343f2479972",
  //     ans:
  //       "In the patient record, click on Consult Notes, click on Add Attachment, click on the relevant template. Complete required fields. Click Save. Complete the consultation notes for that consult and click Add Note. The consultation note with the attachment is now saved. Click on the 3 dots in the attachment, and click Send to Patient. The patient will now have a copy of the attachment in their Instant Consult Inbox, which they can save, print or email.",
  //     query:
  //       "How do I issue a Medical Certificate, Specialist Referral, Pathology Request or Radiology Request using the Instant Consult Service?"
  //   },
  //   {
  //     _id: "5975cf19e46e6343f2479978",
  //     ans:
  //       "We cannot guarantee that there will always be patients requesting consults at all times. Please note, we are constantly keeping track of balancing numbers of consult requests vs. number of doctors available for a consultation, and are making improvements daily.",
  //     query: "Will there always be patients online?"
  //   },
  //   {
  //     _id: "58ef666eeb5d49667c934adg",
  //     ans:
  //       "Instant Consult provides you with the ability to have a health consultation with a patient via video call, anywhere in Australia. We provide a platform for effective health consultations supplementing the traditional health care system. The ultimate benefit of Instant Consult is the convenience; not only to patients, but to yourself. You can work from home, your office, at the airport, in between in-room consultations, and even travelling.",
  //     query: "What is Instant Consult?"
  //   },
  //   {
  //     _id: "5975cf37e46e6343f247997a",
  //     ans:
  //       "All internet traffic on Instant Consult use 256 bit SSL Certificates, which includes digital certificate authentication and 256 bit data encryption. 256 bit SSL Certificates are trusted by over 99.9% of current Internet users. Positive SSL is the solution for new websites and environments where trust has been established and entity verification (for identity assurance) is not needed.",
  //     query: "What security does Instant Consult use?"
  //   },
  //   {
  //     _id: "58ef666eeb5d49667c934adi",
  //     ans:
  //       "Instant Consult provides you with the ability to have a health consultation with a patient via video call, anywhere in Australia. We provide a platform for effective health consultations supplementing the traditional health care system. The ultimate benefit of Instant Consult is the convenience; not only to patients, but to yourself. You can work from home, your office, at the airport, in between in-room consultations, and even travelling.",
  //     query: "What is Instant Consult?"
  //   },
  //   {
  //     _id: "58ef666eeb5d49667c934adj",
  //     ans:
  //       "Instant Consult provides you with the ability to have a health consultation with a patient via video call, anywhere in Australia. We provide a platform for effective health consultations supplementing the traditional health care system. The ultimate benefit of Instant Consult is the convenience; not only to patients, but to yourself. You can work from home, your office, at the airport, in between in-room consultations, and even travelling.",
  //     query: "What is Instant Consult?"
  //   }
  // ];

  return (
    <div className="faq-list">
      {data.map((data, index) => {
        return (
          <ExpansionPanel key={data._id}>
            <ExpansionPanelSummary
              expandIcon={<i className="fas fa-angle-down"></i>}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="faq-query">{data.query}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography className="faq-ans text-justify">
                {/* {data.ans} */}
                <span dangerouslySetInnerHTML={{__html: data.ans}} />
                {/* {{__html: data.ans}} */}
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        );
      })}
    </div>
  );
}
